var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-middle",staticStyle:{"background-color":"rgba(0,0,0,.1)","z-index":"1051"},on:{"click":function($event){return _vm.$store.commit('progress')}}},[_c('div',[_c('b-spinner',{key:"primary",staticStyle:{"width":"3rem","height":"3rem","border-width":"0.3rem !important"},attrs:{"variant":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }